import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { fetchItinerary } from "../api";
import { ChatActionType, Itinerary, TripDay } from "../types";

import api from "../api";
import { apiRoutes, routes } from "../routes/routes";
import LoadingMessage from "../components/LoadingMessage";
import { create_content_from_output } from "../functions/ItineraryUtils";
import ItineraryCard from "../components/Itinerary/ItineraryCard";
import { updateItinerary } from "../functions/Query";
import ChatHeader from "../components/ChatHeader";
import ChatActions from "../components/ChatActions";

export default function ItineraryPage() {
  const [itinerary, setItinerary] = useState<Itinerary | null>(null);
  const [itinKey, setItinKey] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [loadingTravelArrangement, setLoadingTravelArrangement] =
    useState(false);
  const { uuid } = useParams();
  const location = useLocation();

  const pathname = location.pathname.startsWith("/itinerary")
    ? "itinerary"
    : "chat";

  const navigate = useNavigate();

  const getTravelArrangements = async (itinerary: Itinerary) => {
    setLoadingTravelArrangement(true);
    const itinPrompt = create_content_from_output(itinerary);

    try {
      const response = await api.post(apiRoutes.travel_arrangements, {
        prompt: itinPrompt,
      });

      const itinData = response.data;

      itinerary.data = { ...itinerary.data, ...itinData };


    } catch (err) {
    } finally {
      setLoadingTravelArrangement(false);
    }
  };

  useEffect(() => {
    const loadItinerary = async () => {
      setItinerary(null);
      
      const searchParams = new URLSearchParams(location.search);
      const departure_city = searchParams.get("from");
      const departure_date = searchParams.get("date");
      let changes = 0;

      if (!uuid) {
        navigate(routes.chat.path);
        return;
      }

      try {
        const response = await api.get(
          apiRoutes.itinerary_detail.replace(":uuid", uuid)
        );
        const itinResponse = response.data;
        setItinerary(itinResponse);
        setItinKey(Math.round(Math.random() * 1e7))
        setLoading(false);

        if (!itinResponse.data.departure_city && departure_city) {
          itinResponse.data.departure_city = departure_city;
          changes++;
        }
        if (!itinResponse.data.departure_date && departure_date) {
          itinResponse.data.departure_date = departure_date;
          changes++;
        }
        if (itinResponse?.message?.conversation) {
          document.title = itinResponse.message.conversation.title;
        }

        if (!itinResponse.data.cities) {
          //launch search for travel arrangements: transport, hotels, activities, rental car
          await getTravelArrangements(itinResponse);
          changes++;
        }

        if (changes > 0) {
          await updateItinerary(uuid, { data: itinResponse.data });
          if (searchParams.toString() !== "") {
            navigate(location.pathname, {
              replace: true,
            });
          }
          setItinKey(Math.round(Math.random() * 1e7))
        }
      } catch (err) {}
    };

    loadItinerary();
  }, []);

  return (
    <div>
      <div className="bg-light">
        {(loading || loadingTravelArrangement) && (
          <div style={{ maxWidth: "75%" }} className="w-100">
            <LoadingMessage />
          </div>
        )}

        {itinerary && (
          <div>
            <ItineraryCard itinerary={itinerary} key={itinKey} />
          </div>
        )}
      </div>
    </div>
  );
}
